module.exports = "/_next/static/images/robot-arm 1-afa767c88b202fc82f5d3a931ee57f89.svg";